module.exports = __webpack_public_path__ + "img/portal-investidor-icon.833a98f9.svg";